import { atom } from 'jotai';

import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';

export const shouldRequestVideoAtom = atom(get => {
  const vehicle = get(currentVehicleAtom);
  const flags = get(flagsAtom);

  if (!vehicle) return false;

  //NOTE: conditional copied from 'Components/Pdp/LeadCTAs/LeadCtaConfig' -> 'request-video'.isActive
  const shouldRequestVideo = !!(
    flags?.pdpRequestVideoCta &&
    !vehicle?.videos?.[0]?.link &&
    (vehicle?.pricing.package?.requestVideo ?? true)
  );

  return shouldRequestVideo;
});
